<template>
  <div class="alert-container">
    <v-alert
      v-for="alert in alerts"
      :key="alert.id"
      :type="alert.type"
      :color="alert.color"
      :icon="alert.icon"
      :closable="true"
      :duration="3000"
      :timeout="3000"
      close-icon="mdi-close"
      class="alert-item mb-2"
      elevation="4"
      @click:close="removeAlert(alert.id)"
      
    >
      {{ alert.message }}
    </v-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AlertComponent',
  computed: {
    ...mapGetters('alerts', ['alerts'])
  },
  methods: {
    ...mapActions('alerts', ['removeAlert'])
  }
}
</script>

<style scoped>
.alert-container {
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: 9999;
  max-width: 400px;
  width: 100%;
}

.alert-item {
  margin-bottom: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

@media (max-width: 600px) {
  .alert-container {
    right: 10px;
    left: 10px;
    max-width: none;
  }
}
</style> 